export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "highlight_worker.bc2d428a.worker.js");
}
